export interface DivisionView {
  id: string
  legalEntityId: string | null
  code: string
  name: string
  parentId: string | null
  parentName: string | null
  headEmployeeId: string | null
  headEmployeeName: string | null
  active: boolean
  sortOrder: number | null
  /** How many people are placed here today — what makes deactivating it a decision. */
  assignedCount: number
}

export type BankChannel = 'BANK' | 'EXCHANGE_HOUSE' | 'CASH'

export const BANK_CHANNELS: { value: BankChannel; label: string }[] = [
  { value: 'BANK', label: 'Bank' },
  { value: 'EXCHANGE_HOUSE', label: 'Exchange house' },
  { value: 'CASH', label: 'Cash' },
]

export interface EstablishmentView {
  id: string
  legalEntityId: string | null
  code: string
  name: string
  /** The MOHRE establishment number. WPS files are generated per establishment. */
  mohreEstablishmentId: string | null
  wpsEmployerId: string | null
  bankChannel: BankChannel | null
  bankName: string | null
  routingCode: string | null
  licenceNumber: string | null
  licenceExpiry: string | null
  address: string | null
  active: boolean
  assignedCount: number
}

// --- Phase 7 part 5: the masters that had no screens ---

export interface DepartmentView {
  id: string
  code: string
  name: string
  parentId: string | null
  headEmployeeId: string | null
  headEmployeeName: string | null
  sortOrder: number | null
  active: boolean
  headcount: number
}

export interface DepartmentNode {
  department: DepartmentView
  children: DepartmentNode[]
}

export interface LegalEntityView {
  id: string
  code: string
  name: string
  registrationNo: string | null
  countryCode: string | null
  baseCurrency: string | null
  timezone: string | null
  countryPack: string | null
}

export interface CostCenterView {
  id: string
  code: string
  name: string
  glCode: string | null
  ownerEmployeeId: string | null
  active: boolean
}

export interface GradeView {
  id: string
  code: string
  name: string
  level: number
  minSalary: number | null
  maxSalary: number | null
  active: boolean
}

export interface LocationView {
  id: string
  code: string
  name: string
  city: string | null
  countryCode: string | null
  timezone: string | null
  active: boolean
  headcount: number
}

export interface DesignationView {
  id: string
  code: string
  name: string
  gradeId: string | null
  gradeName: string | null
  active: boolean
}

/**
 * A seat, as distinct from the person in it.
 *
 * <p>`status` is VACANT, FILLED, FROZEN or CLOSED. FILLED is a consequence of somebody being
 * assigned, never a setting; CLOSED is what deactivating does, and the row stays so a
 * requisition raised against it keeps resolving.
 */
export interface PositionView {
  id: string
  code: string
  title: string
  departmentId: string | null
  departmentName: string | null
  status: string
  occupantEmployeeId: string | null
  occupantName: string | null
  keyPosition: boolean
}
